import LeftNavigationOpenLinks from './LeftNavigationOpenLinks';

export default LeftNavigationOpenLinks;
